import { CustomTableColumn } from "./custom-table-column";

export class ActionExecutionTableColumn extends CustomTableColumn {
    disabled: boolean;

    constructor(disabled: boolean) {
        super('executionState', 'executionProperty', 'executionState');
        this.disabled = disabled;
    }
}